/**
 * Filters analytics groups by selected homegroup IDs.
 * If no IDs are selected, returns the original array.
 *
 * @param analytics - The analytics array to filter
 * @param selectedHomegroupIds - Array of selected homegroup IDs
 * @returns The filtered analytics array, or the original if no IDs are selected
 *
 * @example
 *   const filtered = filterAnalyticsByHomegroup(analytics, ["hg1", "hg2"])
 */
export function filterAnalyticsByHomegroup<
  T extends { data: { grouped_by: string }[] },
>(analytics: T[] | undefined, selectedHomegroupIds: string[]): T[] | undefined {
  if (!analytics || selectedHomegroupIds.length === 0) {
    return analytics
  }
  return analytics.filter(
    (group) =>
      Array.isArray(group.data) &&
      group.data[0] &&
      selectedHomegroupIds.includes(group.data[0].grouped_by)
  )
}
